import {HighlightStyle, syntaxHighlighting} from '@codemirror/language';
import {tags} from '@lezer/highlight';
import {
  emojiMark,
  htmlTag,
  inlineTag,
  keyboardKeyTag,
  keyboardTag,
  listMarkTag,
  subpageTag,
  userMentionTag,
} from "./markdown.js";

const fonts = [
  {
    tag: tags.monospace,
    fontFamily: '"JetBrains Mono", monospace',
  },
];

const text = [
  {
    tag: tags.emphasis,
    fontStyle: 'italic',
  },
  {
    tag: tags.strong,
    fontWeight: 'bold',
  },
  {
    tag: tags.strikethrough,
    textDecoration: 'line-through',
  },
];

const headings = [
  {
    tag: tags.heading,
    fontWeight: 'bold',
  },
  {
    tag: tags.heading1,
    fontSize: '1.4em',
    fontWeight: 'bold',
  },
  {
    tag: tags.heading2,
    fontSize: '1.3em',
    fontWeight: 'bold',
  },
  {
    tag: tags.heading3,
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  {
    tag: tags.heading4,
    fontSize: '1.1em',
    fontWeight: 'bold',
  },
  {
    tag: tags.heading5,
    fontSize: '1em',
    fontWeight: 'bold',
  },
  {
    tag: tags.heading6,
    fontSize: '0.9em',
    fontWeight: 'bold',
  },
];

const links = [
  {
    tag: tags.link,
    fontWeight: "bold",
  },
  {
    tag: tags.url,
    fontWeight: "normal",
    textDecoration: 'underline',
  },
];

const keyboard = [
  {
    tag: keyboardTag,
    letterSpacing: '-1px',
    fontSize: '0.9em',
  },
  {
    tag: keyboardKeyTag,
    display: 'inline',
    borderRadius: '4px',
    padding: '0 0.3em 0.1em 0.2em',
  },
];

const coyoteSpecific = [
  {
    tag: subpageTag,
    color: '#80a41a',
    fontWeight: 'bold',
  },
  {
    tag: userMentionTag,
    fontWeight: 'bold',
  },
];

const listMark = [{
  tag: listMarkTag,
  'border-radius': '8px',
  display: 'inline-block',
  'text-align': 'center',
  'font-weight': 'bold',
  padding: '0 4px',
}];

const code = [
  {
    tag: inlineTag,
    fontFamily: '"JetBrains Mono", monospace',
  },
  {
    tag: tags.labelName,
    color: '#abb2bf',
  },
];

const emojis = [{
  tag: emojiMark,
  letterSpacing: '-1px',
  fontStyle: 'normal',
  fontWeight: 'normal',
}];

export default [
  syntaxHighlighting(HighlightStyle.define([
    ...text,
    ...fonts,
    ...headings,
    ...links,
    ...keyboard,
    ...coyoteSpecific,
    ...listMark,
    ...code,
    ...emojis,
  ])),
  syntaxHighlighting(HighlightStyle.define([
    {tag: tags.processingInstruction, color: 'black'},
    {tag: htmlTag, color: 'purple', backgroundColor: '#f8efff'},
    {tag: emojiMark, color: 'peru', background: '#fff5ef'},
    {tag: userMentionTag, color: '#5e7813', background: '#effff1'},
    {tag: keyboardTag, color: '#b0d3b9'},
    {
      tag: keyboardKeyTag,
      color: '#232629',
      textShadow: ' 0 1px 0 white',
      backgroundColor: '#e7e7e7',
      border: '1px solid #9ea5ae',
      boxShadow: '0 1px 1px hsl(210deg 8% 5% / 15%), inset 0 1px 0 0 hsl(0 0% 100%)',
    },
    {tag: tags.link, color: 'black'},
    {tag: tags.url, color: 'gray'},
    {tag: listMarkTag, 'background-color': 'whiteSmoke'},
    {tag: inlineTag, backgroundColor: '#f2f2f2'},
  ], {themeType: 'light'})),
  syntaxHighlighting(HighlightStyle.define([
    {tag: tags.processingInstruction, color: 'white'},
    {tag: htmlTag, backgroundColor: 'purple', color: '#f8efff'},
    {tag: emojiMark, background: 'peru', color: '#fff5ef'},
    {tag: userMentionTag, background: '#5e7813', color: '#effff1'},
    {tag: keyboardTag, color: '#418352'},
    {
      tag: keyboardKeyTag,
      color: '#acacac',
      backgroundColor: '#101010',
      border: '1px solid #2f2f2f',
      boxShadow: '0 1px 1px #242a30;',
    },
    {tag: tags.link, color: 'white'},
    {tag: tags.url, color: '#a0a0a0'},
    {tag: listMarkTag, background: '#505050'},
    {tag: inlineTag, backgroundColor: '#2f2f2f'},
  ], {themeType: 'dark'})),
];
